export const FIELD_NAME = 'name';
export const FIELD_ADDRESS = 'address';
export const FIELD_DESCRIPTION = 'description';
export const FIELD_ROLE = 'role';
